import { createContext } from 'react';
export const ApiClientErrorHandlersContext = createContext({});
